/**
 * Lite 商家類型：席次(羽球)
 * 僅此類型具備預繳相關功能（活動商品預繳專用、發佈時帶入預繳、交付時設定預繳、預繳名單等）
 */
export const LITE_SHOP_TYPE_SEAT_BADMINTON = '席次(羽球)';
/**
 * 是否為具預繳功能的 Lite 商家類型
 */
export function isLitePrepaidShopType(type) {
    return type === LITE_SHOP_TYPE_SEAT_BADMINTON;
}
